import React, { useContext } from "react"

import { gql, useQuery } from "urql"

import { AlertLevel } from "~tailwindui/types/enums"

import OpportunityCard from "~Tutor/Pages/RequestedSessions/RequestedSessionCard"
import TutorContext from "~Tutor/TutorContext"
import { AlertMessageBox, H2, WithLoadingIndicator } from "~tailwindui/Basics"

const RequestedSessionsPage = () => {
  const { viewer } = useContext(TutorContext)
  const [result, refetchQuery] = useQuery({
    query: requestedSessionsQuery,
    variables: {},
  })
  return (
    <>
      <AlertMessageBox level={AlertLevel.Info}>
        When a tutor requests a substitute for a session that you are eligible
        to accept, that session will appear here.
      </AlertMessageBox>

      {viewer.hasUnbilledSessions && (
        <AlertMessageBox level={AlertLevel.Warning}>
          You will not be able to accept any new sessions until you bill your
          completed sessions.
        </AlertMessageBox>
      )}

      <WithLoadingIndicator result={result}>
        {({ data: { viewer } }) => (
          <>
            {viewer.newRequestedSessions.data.length > 0 && (
              <>
                <H2>Requested Sessions</H2>
                <div className="flex flex-wrap gap-10">
                  {viewer.newRequestedSessions.data.map(session => (
                    <OpportunityCard
                      key={session.id}
                      session={session}
                      refetchQuery={refetchQuery}
                    />
                  ))}
                </div>
              </>
            )}

            {viewer.substituteRequestedSessions.data.length > 0 && (
              <>
                <H2>Substitute Opportunities</H2>
                <div className="flex flex-wrap gap-10">
                  {viewer.substituteRequestedSessions.data.map(session => (
                    <OpportunityCard
                      key={session.id}
                      session={session}
                      refetchQuery={refetchQuery}
                    />
                  ))}
                </div>
              </>
            )}
          </>
        )}
      </WithLoadingIndicator>
    </>
  )
}

const requestedSessionsQuery = gql`
  query RequestedSessions {
    viewer {
      newRequestedSessions: sessions(filters: { statusState: requested }) {
        data {
          id
          startsAt
          endsAt
          statusState
          formattedScheduledDuration
          foreignLanguage {
            id
            name
          }
          studyGroup {
            id
            name
          }
          students {
            id
            fullName
          }
          subject {
            id
            name
          }
        }
      }
      substituteRequestedSessions: sessions(
        filters: { statusState: substitute_requested, future: true }
      ) {
        data {
          id
          startsAt
          endsAt
          statusState
          formattedScheduledDuration
          formattedSubstituteNotes
          originalTutor {
            id
            fullName
          }
          foreignLanguage {
            id
            name
          }
          studyGroup {
            id
            name
          }
          students {
            id
            fullName
          }
          subject {
            id
            name
          }
        }
      }
    }
  }
`

export default RequestedSessionsPage
